<div class="card-principal mt-4" *ngIf="pasosSeguir !== 'NO_STEPS'">
  <p class="siguientes-pasos">Siguientes pasos </p>
  <!-- Estructura de pasos individuales-->
  <div>
    <div *ngFor="let prod of this.stepsToFollow.products;">
      <!-- Product Title -->
      <div *ngIf="prod.productTitle" class="row">
        <div class="col-md-12">
          <p class="subtitulo-producto">{{ prod.productTitle }}</p>
        </div>
      </div>
      <!-- Repeteable element with last element with conditional class-->
      <div *ngFor='let step of prod.steps; last as isLast;' class="row">
        <div class="col-2 col-sm-1">
          <div class="circulo"></div>
          <div [ngClass]="{'linea-recta': !isLast, 'linea-recta-2' : isLast }"></div>
        </div>
        <div class="col-10 col-sm-11">
          <div class="titulo-informativo" [innerHTML]="step.title"></div>
          <p class="parrafo-informativo" [innerHTML]="step.subtitle"></p>
        </div>
      </div>
    </div>
    <!-- Extra element asociated to action button -->
    <div *ngIf="this.stepsToFollow.isWix" class="row">
      <div class="col-2 col-sm-1"></div>
      <div class="col-10 col-sm-11">
        <button class="btn-secondary-tbk-L centrar-btn" (click)="agendaWix()">Agenda tu asesoría</button>
      </div>
    </div>
    <!-- Extra element asociated to helper/info -->
    <div class="row">
      <div class="col-2 col-sm-1"></div>
      <div class="col-10 col-sm-11">
        <app-messages class="informativoSS mt-16 mb-16 p-16"
                      message="Si tienes dudas o consultas llamanos desde celulares al <strong>+56 2 2661 27 00</strong> o desde teléfonos fijos al <strong>600 638 6380</strong>.">
        </app-messages>
      </div>
    </div>
  </div>